<template>
  <el-row :gutter="30" class="preview-text text-left">
    <el-col :span="24" :md="12">
      <p>
        <span>คำนำหน้าชื่อ: </span
        ><span v-if="prefix">{{ getPrefixLabel(prefix) }} </span>
        <i v-else class="small">ไม่มีข้อมูล</i>
        <span class="pd-l-4">ชื่อภาษาไทย: </span
        ><span v-if="nameTh">{{ nameTh }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>นามสกุลภาษาไทย: </span
        ><span v-if="lastNameTh">{{ lastNameTh }} </span>
        <i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ชื่อภาษาอังกฤษ: </span><span v-if="nameEn">{{ nameEn }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>นามสกุลภาษาอังกฤษ: </span
        ><span v-if="lastNameEn">{{ lastNameEn }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>อีเมล: </span
        ><span v-if="email">{{ email }} </span>
        <i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>หมายเลขโทรศัพท์: </span
        ><span v-if="phoneNumber">{{ phoneNumber }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" >
      <p>
        <span>ตำแหน่งงาน: </span><span v-if="position">{{ position }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ชื่อหน่วยงาน/องค์กร/บริษัท: </span><span v-if="agency">{{ agency }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ที่อยู่: </span><span v-if="address">{{ address }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>ตำบล/แขวง: </span><span v-if="subDistrict">{{ subDistrict }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>อำเภอ/เขต: </span><span v-if="district">{{ district }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>จังหวัด: </span><span v-if="province">{{ province }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
    <el-col :span="24" :md="12">
      <p>
        <span>รหัสไปรษณีย์: </span><span v-if="postcode">{{ postcode }} </span
        ><i v-else class="small">ไม่มีข้อมูล</i>
      </p></el-col
    >
  </el-row>
</template>

<script>
export default {
  props: {
    prefix: {
      default() {
        return "";
      },
    },
    email: {
      type: String,
      default() {
        return "";
      },
    },
    nameTh: {
      type: String,
      default() {
        return "";
      },
    },
    lastNameTh: {
      type: String,
      default() {
        return "";
      },
    },
    nameEn: {
      type: String,
      default() {
        return "";
      },
    },
    lastNameEn: {
      type: String,
      default() {
        return "";
      },
    },
    phoneNumber: {
      type: String,
      default() {
        return "";
      },
    },
    position: {
      type: String,
      default() {
        return "";
      },
    },
    agency: {
      type: String,
      default() {
        return "";
      },
    },
    address: {
      type: String,
      default() {
        return "";
      },
    },
    subDistrict: {
      type: String,
      default() {
        return "";
      },
    },
    district: {
      type: String,
      default() {
        return "";
      },
    },
    province: {
      type: String,
      default() {
        return "";
      },
    },
    postcode: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    prefixList() {
      return this.$store.state.prefixList;
    },
  },
  methods: {
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>